/* istanbul ignore next */
export default {
  locationStub: {
    query: {},
  },
};



// WEBPACK FOOTER //
// ./utils/locationUtils/locationUtils.js